export const SYNC_FAILED_NODE_CHANNEL = '@@myDevices/failedNodeChannelSync'
export const SYNC_FAILED_NODE_CHANNEL_SENT = '@@myDevices/failedNodeChannelSyncSent'
export const OPEN_FAILED_NODE_CHANNEL = '@@myDevices/failedNodeChannelOpen'
export const CLOSE_FAILED_NODE_CHANNEL = '@@myDevices/failedNodeChannelClose'
export const UPDATE_FAILED_NODE = '@@myDevices/failedNodeChannelUpdate'
